import { compose, withProps } from 'recompose'
import withAddToQuote from 'components/common/hoc/withAddToQuote/withAddToQuote'
import withCheckActiveVehicle from 'components/common/hoc/withCheckActiveVehicle'
import { isMobile } from 'components/common/Media/helpers'

import AddToQuoteButton from './AddToQuoteButton'
import AddToQuoteButtonMobile from './AddToQuoteButtonMobile'

const withDeviceType = withProps(() => ({
  deviceType: isMobile() ? 'mobile' : 'desktop'
}))

const enhance = compose(
  withDeviceType,
  withAddToQuote,
  withCheckActiveVehicle
)

export const ButtonWithAddToQuoteHandler = enhance(AddToQuoteButton)
export const MobileButtonWithAddToQuoteHandler = enhance(AddToQuoteButtonMobile)
